// Charter/vacation deal covers come from S3, one photo per destination country — admin picks a
// country (see CharterDealRecordForm in avion-admin) instead of pasting an image URL. Bucket
// layout mirrors the bus-tours convention (tours/getCountryImageUrl.js) but in its own
// "vacation/" folder, since a resort cover shouldn't reuse a bus-tour cover for the same country.
// Older deals saved before this field existed (and the hardcoded mock list in charterDeals.js)
// still carry a plain `image` URL instead — kept as a fallback so they don't lose their photo.
// Keep this map in sync with avion-admin's CHARTER_COUNTRIES (src/constants/index.js) and its
// own copy of this resolver (src/utils/charterDealImage.js, used for the admin table thumbnail)
// whenever a new destination is added — the two apps don't share code.
const COUNTRY_EN = {
  Turcija: "Turkey",
  Ēģipte: "Egypt",
  Albānija: "Albania",
  Bulgārija: "Bulgaria",
  Grieķija: "Greece",
  Melnkalne: "Montenegro",
  Spānija: "Spain",
  Kipra: "Cyprus",
  "Apvienotie Arābu Emirāti": "UAE",
  Portugāle: "Portugal",
  Tunisija: "Tunisia",
  Itālija: "Italy",
  Francija: "France",
  Horvātija: "Croatia",
  Vjetnama: "Vietnam",
  Taizeme: "Thailand",
  Šrilanka: "Sri Lanka",
  Tanzānija: "Tanzania",
  Kenija: "Kenya",
  Maurīcija: "Mauritius",
  Indonēzija: "Indonesia",
};

function buildUrl(folder) {
  return (
    `https://${window.SERVER_DATA.REACT_APP_BUCKET_NAME}.` +
    `${window.SERVER_DATA.REACT_APP_BUCKET_PATH}/vacation/${folder}/cover.png`
  );
}

export function getCharterDealImage(deal) {
  const folder = COUNTRY_EN[deal.country];
  if (folder) return buildUrl(folder);
  return deal.image || null;
}
